import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/courses.action'
import destroyCourse from 'api/administration/courses/Destroy'
import coursesList from 'api/administration/courses/GetList'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function handleDestroy(courseId: number) {
  return await destroyCourse(courseId)
}

function* destroyCourseEffectSaga(action: any) {
  try {
    const { id, params } = action.payload
    const {
      page,
      searchText,
      sort,
      usersFilter,
      perPage: itemsPerPage,
      fastFilters,
    } = params
    yield call(handleDestroy, id)
    const { data, total, perPage } = yield call(
      coursesList,
      page,
      searchText,
      sort,
      usersFilter,
      itemsPerPage,
      fastFilters
    )
    yield put(
      fromActions.Actions.coursesAdministrationListSuccess(
        data,
        total,
        perPage,
        sort
      )
    )
    SuccessToast(I18n.t('administration.toastMessages.courseDeleteSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.courseDeleteError'))
    console.log('error: ', error)
  }
}

export function* destroyCourseWatcherSaga() {
  yield takeLatest(fromActions.DESTROY_COURSE, destroyCourseEffectSaga)
}
